
import UiButton from "~/components/UI/UiButton.vue";

export default {
  name: "SubscriptionFormSuccessInPopUp",
  components: { UiButton },
};
